<template>
        <div class="row">
            <div class="col-md-12 mb-1">
                <label class="form-label">Başlangıç Bölgesi</label>
                <v-select-list v-model="startRegion" placeholder="Başlangıç Bölgesi" label="RegionName" :options="startRegions"/>   
            </div>
            <div class="col-md-12 mb-1">
                <label class="form-label">Bitiş Bölgesi</label>
                <v-select-list v-model="endRegion" placeholder="Bitiş Bölgesi" label="RegionName" :options="endRegions"/>   
            </div>
            <div class="col-md-12 mb-1">
                <label class="form-label">Taşıma Tipi</label>
                <v-select-list placeholder="Taşıma Tipi" v-model="transportStatus" label="Name" :options="vehicleTransportStatuses"/>
            </div>
            <div class="col-md-12 mb-1">
                <label class="form-label">Stok</label>
                <v-select-list v-model="stok" :options="stoks" label="Name" placeholder="Stok" :loading="stokLoading"></v-select-list>
            </div>
            <div class="col-md-12 mb-1">
                <label class="form-label">Araç Tipi</label>
                <v-select-list :options="vehicleTypes" v-model="vehicleType" placeholder="Araç Tipi" label="Name"></v-select-list>
            </div>
            <!-- Düz metin kutusu yerine para girişi: metin kutusu string döndürdüğü için
                 "722.94" yazan kullanıcının fiyatı ayrıştırmada 72294'e dönüşüyordu. -->
            <div class="col-md-12 mb-1">
                <label class="form-label">Fiyat</label>
                <v-currency-input input-class="text-right" :value="value.Price" v-on:update-value="amount => value.Price = amount"></v-currency-input>
            </div>
        </div>
</template>



<script>
import { SystemDataApi } from '@/api/system-data'
import {VehicleTypeApi} from '@/api/vehicle-type'
import {TransferRegionApi} from '@/api/transfer-region'
import {MaterialApi} from '@/api/material'
import VCurrencyInput from '@/components/VCurrencyInput.vue'

export default {
    components:{
        VCurrencyInput
    },
    props:{
        value:Object
    },
    data(){
        return{
            startRegions:[],
            endRegions:[],
            stoks:[],
            vehicleTransportStatuses:[],
            vehicleTypes:[],
            stokLoading:null
            
        }
    },
    mounted(){
        this.getRegions()
        this.getVehicleTransportStatuses()
        this.getVehicleTypes()
        this.getStoks()
    },
    watch:{
    },
    methods:{
        getVehicleTypes(){
            VehicleTypeApi.List().then(res => {
                this.vehicleTypes = res.data.Data
            }).catch(err=> {
                console.error(err)
            })
        },
        getRegions(){
            TransferRegionApi.List().then(res=>{
                this.startRegions = res.data.Data
                this.endRegions = res.data.Data
            })
        },
        getStoks(){
            // // if(searchStokKey){
            // //     this.stokLoading = true
            // //     NetsisApi.StokList(searchStokKey).then(res => {
            // //         this.stoks = res.data.Data
            // //         this.stokLoading = false
            // //     }).catch(err=> {
            // //         console.log(err)
            // //         this.stokLoading = false
            // //     })
            // // }
            this.stokLoading = true
            MaterialApi.List().then(res => {
                this.stoks = res.data.Data
                this.stokLoading = false
            }).catch(err=> {
                console.log(err)
                this.stokLoading = false
            })
        },
        getVehicleTransportStatuses(){
            SystemDataApi.VehicleTransportStatuses().then(res=> {
                this.vehicleTransportStatuses = res.data.Data
            })
        }
    },
    computed:{
        stok:{
            get:function(){
                return this.stoks.find(s=>s.Code==this.value.StockCode)
            },
            set:function(value){
                this.value.StockCode = value?.Code || null
                this.value.StockName = value?.Name || null
            }
        },
        vehicleType:{
            get:function(){
                return this.vehicleTypes.find(s=>s.Id==this.value.VehicleTypeId)
            },
            set:function(value){
                this.value.VehicleTypeName = value?.Name || null
                this.value.VehicleTypeId = value?.Id || null
            }
        },
        transportStatus:{
            get:function(){
                return this.vehicleTransportStatuses.find(b=>b.Value==this.value.VehicleTransportStatus)
            },
            set:function(value){
                this.value.VehicleTransportStatusName = value.Name
                this.value.VehicleTransportStatus = value.Value 
            }
        },
        startRegion:{
            get:function(){
                return this.startRegions.find(b=>b.Id==this.value.StartRegionId)
            },
            set:function(value){
                this.value.StartRegionName =value?.RegionName ||null
                this.value.StartRegionId = value?.Id || null
            }
        },
        endRegion:{
            get:function(){
                return this.endRegions.find(b=>b.Id==this.value.EndRegionId)
            },
            set:function(value){
                this.value.EndRegionName =value?.RegionName ||null
                this.value.EndRegionId = value?.Id || null
            }
        }
    }
}
</script>

<style>

</style>